import React from 'react'
import { IconsProps } from 'msp-integrations'

const DropFilledIcon = (props: IconsProps) => {
  return (
    <svg
      width='20'
      height='23'
      viewBox='0 0 20 23'
      {...props}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d="M9.993 22.758c-5.097 0-9.245-4.148-9.245-9.245C.748 6.919 8.72.517 9.993.517c1.273 0 9.245 6.402 9.245 12.996 0 5.097-4.147 9.245-9.245 9.245Z" />
    </svg>
  )
}

export default DropFilledIcon
